<template>
    <form class="is-clearfix role-form">
      <div class="columns">
        <div class="column">
          <h1 class="title is-3 between-center">
            <span>View Role</span>
          </h1>
        </div>
        <div class="column is-6 toolbar-box">
          <div class="field is-grouped is-grouped-right">
            <p class="control">
              <router-link :to="{ name: 'roles.index' }" class="button is-info" exact>Back</router-link>
            </p>
            <p class="control">
              <a @click.prevent="handleDeletion(role, 'roles.index')" class="button is-danger">Delete</a>
            </p>
            <p class="">
              <router-link v-if="role.id" :to="{ name: 'roles.edit', params: { slug: role.id } }" class="button is-info"><span
                  class="icon"><i class="icm-new"/></span><span>Edit</span></router-link>
            </p>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12-tablet is-12-desktop is-12-widescreen is-3-fullhd">
          <div class="columns is-multiline">
            <div class="column is-3-widescreen is-12-fullhd">
              <div v-for="data in dataResponse" :key="data.id">
                <div class="card" v-if="data.id === roleId">
                  <div class="card-content">
                    <div class="media">
                      <div class="media-content">
                        <p class="title is-4">name: {{ data.name }}</p>
                        <p class="subtitle is-6">description: {{ data.description }}</p>
                        <div v-for="user in userData" :key="user.id">
                          <div v-if="data.last_editor_id === user.id">
                            <p class="subtitle is-6">last editor:
                              {{ data.last_editor_id === user.id ? user.full_name : "no exist" }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns" v-for="data in dataResponse">
        <div class="column" v-if="data.id === roleId">
          <div class="columns toolbar-box">
            <div class="is-2"><h1 class="title is-3 between-center d-block">Role Permissions</h1></div>
          </div>
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th class="center-switch">Enabled</th>
              <th class="center-switch">List</th>
              <th class="center-switch">Show</th>
              <th class="center-switch">Create</th>
              <th class="center-switch">Update</th>
              <th class="center-switch">Delete</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="n in data.permissions" :key="n.key">
              <td>{{ n.name }}</td>
              <td class="td-description">{{ n.description }}</td>
              <td class="center-switch">
                <o-tooltip position="bottom" label="This type does not send email" type="is-info" multiline size="small">
                  <o-switch v-model="n.enabled" disabled></o-switch>
                </o-tooltip>
              </td>
              <td class="center-switch">
                <o-tooltip position="bottom" label="This type does not send notification" type="is-info" multiline size="small">
                  <o-switch disabled v-model="n.list"></o-switch>
                </o-tooltip>
              </td>
              <td class="center-switch">
                <o-tooltip position="bottom" label="This type does not send notification" type="is-info" multiline size="small">
                  <o-switch disabled v-model="n.show"></o-switch>
                </o-tooltip>
              </td>
              <td class="center-switch">
                <o-tooltip position="bottom" label="This type does not send notification" type="is-info" multiline size="small">
                  <o-switch disabled v-model="n.create"></o-switch>
                </o-tooltip>
              </td>
              <td class="center-switch">
                <o-tooltip position="bottom" label="This type does not send notification" type="is-info" multiline size="small">
                  <o-switch disabled v-model="n.update"></o-switch>
                </o-tooltip>
              </td>
              <td class="center-switch">
                <o-tooltip position="bottom" label="This type does not send notification" type="is-info" multiline size="small">
                  <o-switch disabled v-model="n.remove"></o-switch>
                </o-tooltip>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Table from '../../mixins/Table'
import moment from "moment";
import {fetchRoleById} from "../../store/modules/roles/actions";

export default {
  mixins: [Table],

  components: {},

  data() {
    return {
      filters: {
        year: (new Date).getFullYear(),
        month: +moment().format('MM'),
        team_id: null,
        users: [],
      },
      dataResponse: [],
      userData: this.$store.state.users.items,
      permissions: [],
      role: []
    }
  },

  mounted() {
    this.fetchRoleById(this.$route.params.slug)
        .then(value => {
          this.dataResponse.push(value.data.data)
          this.role = value.data.data
        })

  },

  created() {
    // for (let i = 2013; i <= (new Date).getFullYear(); i++) {
    //   console.log(i)
    //   this.year.push(i)
    // }
    // this.fetchRoleById(this.$route.params.slug)
    //     .then(res => {
    //       this.fetched = true
    //       return res
    //     })

  },

  methods: {
    ...mapActions({
      fetchRoleById: 'fetchRoleById',
      removeItem: 'removeRole',
      fetchData: 'fetchRoles',
    }),

    handleDeletion(role) {
      if (role.id === this.currentUserId) {
        return this.$oruga.notification.open({
          type: 'danger',
          text: 'You are trying to delete yourself. Sorry, this action is not allowed'
        })
      }

      this.confirmCustomDelete(role, 'roles.index')
    },

    resetFilters() {
      this.filters = {
        year: (new Date).getFullYear(),
        month: moment().format('MM'),
        team_id: null,
        users: []
      }
    },
  },

  computed: {
    ...mapGetters(['roleById', "userById", 'currentUserId', "allRoles"]),

    roleId() {
      return parseInt(this.$route.params.slug)
    },

    // role() {
    //   return this.roleById(this.roleId)
    // },
    allRole(){
      return this.allRoles
    },
    userId() {
      return parseInt(this.$route.params.slug)
    },

    user() {
      return this.userById(this.userId)
    },
    currentPeriod() {
      return moment().year(this.filters.year).month(this.filters.month - 1).date(1)
    },
    previousPeriod() {
      return moment().year(this.filters.year).month(this.filters.month - 1).date(1).subtract('months', 1)
    },
    currentYear() {
      return this.currentPeriod.format('YYYY')
    },
    currentMonth() {
      return this.currentPeriod.format('MM')
    },
    previousYear() {
      return this.previousPeriod.format('YYYY')
    },
    previousMonth() {
      return this.previousPeriod.format('MM')
    },
    paramsCurrent() {
      return {year: this.currentYear, month: this.currentMonth, users: [this.user.id]}
    },
    paramsPrevious() {
      return {year: this.previousYear, month: this.previousMonth, users: [this.user.id]}
    },
    ratingData() {
      return {billingData: this.billingData, nonBillableData: this.nonBillableData, timelogData: this.timelogData}
    },
  },
}
</script>
<style>
.mt-0 {
  margin-top: 0 !important;
}

.text-muted {
  --ct-text-opacity: 1;
  color: #98a6ad !important;
}

.badge {
  vertical-align: middle;
}

.bg-alert {
  background-color: #ee4d4d !important;
}

.bg-primary {
  background-color: #77b477 !important;
}


.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: .75em;
  font-weight: 700;
  line-height: 1;
  color: #ffffff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.card.tilebox-one {
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0px 0px 2px 1px #0000000f;
}

h2.m-b-20 {
  font-size: 1.875rem;
}

.role-form .table tr:nth-child(even) {
  background-color: #f2f2f2;
}

.role-form .table tr:nth-child(odd) {
  background-color: #fff;
}

.role-form .table thead {
  border-bottom: 1px solid #f0f0f0
}

.role-form .table {
  border: none !important;
}

.role-form .table .center-switch {
  width: 179px;
  text-align: center !important;
}

.role-form tr.no-padding td {
  padding: 17px 9px;
  font-weight: bold;
  background-color: #e3e7ed;
  min-width: 165px;
}

.role-form td.td-description {
  width: 100%;
}

@media (min-width: 1380px) and (max-width: 1599px) {
  .role-form .table td {
    padding: 10px 9px;
  }
}

.role-form .switch[disabled] {
  opacity: 0.2;
}
</style>